<template>
  <v-navigation-drawer
    v-model="internalVisible"
    right
    temporary
    fixed
    :width="drawerWidth"
    app
    class="drawer-quote d-flex flex-column"
    style="height: 100vh; overflow: hidden"
  >
    <div
      class="pa-4"
      ref="scrollContent"
      style="
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        height: 100%;
      "
    >
      <v-card-title class="text-h4 d-flex align-center justify-center">
        <div>
          <!-- Cotizá materiales para tu proyecto -->
          Compras
        </div>
        <v-spacer></v-spacer>
        <v-btn icon medium @click="close" style="border: 1px solid #000">
          <v-icon medium color="#000">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="payments.length > 0">
        <v-row v-if="project">
          <v-col>
            <div class="text-subtitle-1">
              Estas son todas las compras asignadas al proyecto:
              <b>{{ project.name }}</b>
            </div>
            <!-- <div class="font-weight-medium text-subtitle-2">Puedes seleccionar y desasignar las compras</div> -->
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="8" class="d-flex align-center">
            <v-chip color="black" text-color="white" class="ma-0">
              <v-avatar left class="secondary">
                <b>{{ total }}</b>
              </v-avatar>
              Compras asginadas
            </v-chip>
          </v-col>

          <v-col cols="4" class="d-flex justify-end align-center">
            <div class="text-right">
              <v-btn
                medium
                color="black"
                @click="showFilters = !showFilters"
                outlined
                rounded
              >
                <v-icon left small>
                  {{ showFilters ? "mdi-chevron-up" : "mdi-filter" }}
                </v-icon>
                Filtros
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-expand-transition>
              <div v-show="showFilters">
                <FiltersPurchases
                  v-model="filters"
                  @change="onFiltersChange"
                  :suppliers="suppliers"
                  @close="showFilters = false"
                />
              </div>
            </v-expand-transition>
          </v-col>
        </v-row>

        <v-col>
          <v-expand-transition>
            <div v-show="!showFilters">
              <template v-if="hasActiveFilters">
                <v-chip
                  v-if="filters.supplier_id"
                  class="ma-1"
                  close
                  @click:close="clearFilter('supplier_id')"
                  small
                  color="black"
                  text-color="white"
                >
                  Proveedor: <b>{{ getSupplierName(filters.supplier_id) }}</b>
                </v-chip>

                <v-chip
                  v-if="filters.date_from"
                  class="ma-1"
                  close
                  @click:close="clearFilter('date_from')"
                  small
                  color="black"
                  text-color="white"
                >
                  Desde: <b>{{ filters.date_from }}</b>
                </v-chip>

                <v-chip
                  v-if="filters.date_to"
                  class="ma-1"
                  close
                  @click:close="clearFilter('date_to')"
                  small
                  color="black"
                  text-color="white"
                >
                  Hasta: <b>{{ filters.date_to }}</b>
                </v-chip>
              </template>
            </div>
          </v-expand-transition>
        </v-col>

        <v-card
          class="mb-2"
          v-for="payment in payments"
          :key="payment.id"
          outlined
        >
          <v-card-text class="d-flex align-center">
            <div>
              <div class="text-subtitle-1 font-weight-bold" style="color: #000">
                {{ payment.id }} - {{ payment.supplier_name }}
              </div>
              <div class="text-subtitle-2">
                {{ payment.created_at }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <div class="text-subtitle-1 font-weight-bold" style="color: #000">
              {{ payment.amount | currency }}
            </div>
          </v-card-text>
        </v-card>

        <v-pagination
          v-if="total > per_page"
          v-model="current_page"
          :length="last_page"
          class="mt-4 mb-4 d-flex justify-center custom-pagination"
          @input="onPageChange"
        />
      </v-card-text>
      <v-card-text v-else>
        <v-row class="text-h6 font-weight-light mt-5">
          <v-col cols="12">
            12
            <v-card
              class="text-center"
              elevation="0"
              outlined
              style="border-radius: 16px; padding-bottom: 2em"
            >
              <v-icon size="48" color="grey darken-2" class="mb-4"
                >mdi-truck-search-outline</v-icon
              >

              <h3 class="text-h6 font-weight-bold mb-2">
                Todavía no hay compras para asignar a este proyecto
              </h3>

              <p class="text-body-2 mb-4" style="color: #666">
                Puede que aún no hayas comprado materiales, o que ya hayas
                asignado todas tus compras a otros proyectos. No te preocupes,
                podés seguir avanzando:
              </p>

              <v-row justify="center" align="center" class="mt-2">
                <v-btn
                  color="primary"
                  class="mr-2"
                  small
                  :to="{ name: 'where-buy' }"
                  elevation="0"
                  style="border-radius: 16px"
                >
                  <v-icon left small>mdi-store-search</v-icon>
                  Explorar proveedores
                </v-btn>

                <v-btn
                  color="black"
                  dark
                  small
                  @click="handleMakeQuote"
                  elevation="0"
                  style="border-radius: 16px"
                >
                  <v-icon left small>mdi-file-document-edit-outline</v-icon>
                  Realizar cotización
                </v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-navigation-drawer>
</template>

<script>
import PaymentService from "@/services/paymentService";
import CustomerService from "@/services/customerService";
import FiltersPurchases from "@/components/projects/assignPurchases/FiltersPurchases.vue";

export default {
  name: "DialogAssignPurchases",

  components: {
    FiltersPurchases,
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    project: {
      type: Object,
      default: () => ({
        id: null,
        name: null,
        budget: null,
        address: null,
        start_date: null,
        type_id: null,
        phase_id: null,
      }),
    },
  },

  created() {
    this.getPayments();
    this.getSuppliers();
  },

  data() {
    return {
      payments: [],
      show: this.visible,
      selectedProjectx: { ...this.project },
      loading: false,
      selectedProjects: [],
      //pagination
      current_page: 1,
      last_page: 1,
      total: 1,
      per_page: null,
      // filtros
      filters: {
        supplier_id: null,
        date_from: null,
        date_to: null,
      },
      suppliers: [],
      showFilters: false, // nuevo
      internalVisible: this.visible,
    };
  },

  computed: {
    isFormComplete() {
      return this.selectedProjects.length == 0;
    },

    drawerWidth() {
      return this.$vuetify.breakpoint.mdAndDown ? "100%" : "40%";
    },

    hasActiveFilters() {
      return (
        this.filters.supplier_id ||
        this.filters.date_from ||
        this.filters.date_to
      );
    },
    getSupplierName() {
      return (id) => {
        const supplier = this.suppliers.find((s) => s.id === id);
        return supplier ? supplier.name || supplier.business_name : "Proveedor";
      };
    },
  },
  methods: {
    async getSuppliers() {
      const response = await CustomerService.getSuppliers();
      const result = await response.json();
      this.suppliers = result;
    },

    async getPayments(page = 1) {
      try {
        const params = {};

        params["page"] = page;
        params["project_id"] = this.project.id;

        Object.entries(this.filters).forEach(([key, value]) => {
          if (value !== null && value !== "") {
            params[key] = value;
          }
        });

        const response = await PaymentService.getPaymentsToProject(params);

        if (response.ok) {
          const result = await response.json();
          this.payments = result.data;
          // pagination
          this.current_page = result.current_page;
          this.last_page = result.last_page;
          this.total = result.total;
          this.per_page = result.per_page;
        } else {
          console.error("Error al obtener pagos:", response.status);
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },

    async handleSubmit() {
      let data = {};

      data["project_id"] = this.project.id;
      data["payment_ids"] = this.selectedProjects;

      this.loading = true;

      try {
        let response = null;
        response = await PaymentService.assignProjectToPayment(data);

        if (response.ok) {
          // const result = await response.json()
          this.close();
        }
      } catch (error) {
        console.error("Error al actualizar el proyecto");
      } finally {
        this.loading = false;
      }
    },

    onDrawerToggle(val) {
      if (!val) {
        this.close();
      }
    },

    close() {
      this.resetForm();
      this.$emit("close");
    },

    resetForm() {
      this.selectedProjects = [];
    },

    onPageChange(page) {
      this.getPayments(page);
    },

    onFiltersChange(newFilters) {
      console.log(newFilters, "filters");
      this.filters = newFilters;
      console.log(this.filters, "filters");
      this.showFilters = false;
      this.getPayments(1);
    },

    clearFilter(key) {
      this.filters[key] = null;
      this.getPayments(1);
    },

    handleMakeQuote() {
      this.$emit("handleMakeQuote", null);
      this.close();
    },
  },

  watch: {
    visible(val) {
      this.internalVisible = val;
      if (val) this.getPayments();
    },
    internalVisible(val) {
      this.$emit("update:visible", val);
      if (!val) this.close();
    },
  },

  filters: {
    currency(value) {
      var formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      });

      return formatter.format(value);
    },
  },
};
</script>

<style scoped>
.btn-disabled {
  background-color: #f2f2f2 !important;
  color: #999 !important;
  border-color: #ddd !important;
  cursor: not-allowed !important;
}

.btn-enabled {
  background-color: #1d1d1f !important;
  color: white !important;
  border-color: #1d1d1f !important;
}

.preview-quote {
  max-height: 100px;
  min-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  padding: 12px;
  font-size: 0.9em;
  font-family: monospace;
  background-color: #f5f5f5;
  /* border: 1px solid #ddd; */
  border-radius: 4px;
  box-sizing: border-box;
  max-width: 800px !important;
}

@media (max-width: 998px) {
  .project-form-buttons {
    padding-bottom: 30% !important;
  }
}

.custom-pagination >>> .v-pagination {
  background-color: #f5f5f5;
  padding: 10px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-pagination >>> .v-pagination__item {
  color: #000;
  font-weight: 500;
  border-radius: 6px;
}

.custom-pagination >>> .v-pagination__item--active {
  background-color: #1d1d1f !important;
  color: white !important;
}
</style>
